import { Controller } from "@hotwired/stimulus"

// Handles replacing image or audio files via file upload.
// When the "Replace" button is clicked, opens a native file picker,
// then uploads the selected file to the replace endpoint.
export default class extends Controller {
  static targets = ["fileInput", "status", "filename"]
  static values = {
    url: String,
    accept: { type: String, default: "image/*" },
    mediaType: { type: String, default: "image" }
  }

  openFilePicker() {
    this.fileInputTarget.click()
  }

  async fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    this.updateStatus("Uploading...")

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const formData = new FormData()
      formData.append("file", file)

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: formData
      })

      if (response.ok) {
        const data = await response.json()
        this.updateStatus("Replaced")
        if (this.hasFilenameTarget) {
          this.filenameTarget.textContent = data.filename || file.name
        }
        // Reload to show updated content
        setTimeout(() => {
          window.location.reload()
        }, 500)
      } else {
        const data = await response.json().catch(() => ({}))
        this.updateStatus(`Error: ${data.error || "Upload failed"}`)
      }
    } catch (error) {
      console.error("Replace upload failed:", error)
      this.updateStatus("Upload failed")
    }

    // Reset file input for subsequent uploads
    event.target.value = ""
  }

  updateStatus(text) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
    }
  }
}
